import axios from "axios";

const BackendRestClientWithoutHeaders = axios.create({
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    },
});

export default BackendRestClientWithoutHeaders;
